export class EstadoCivil{
    public id_estado_civil_pk:Number;
    public estado_civil:String;
    
}